<template lang="pug">
  div.wrap-event-suggestion.pb60
    div.message.py40
      div.f.fc.mb4
        span.block.bold あなたにおすすめのトレーニングです。
      div.f.fc.mb8
        span.block.bold ライブフィットネスを予約しましょう！
      div.f.fc
        span.fz12 * 予約内容は後から変更もできます。
    div
      ItemSuggestedEventCard(
        v-for="item in suggestedEvents"
        :content="item"
        :key="item.id")
</template>

<style lang="scss" scoped>
.wrap-event-suggestion {
  width: 100%;
  min-height: 100vh;
  .message {
    border-bottom: solid rgba(0, 0, 0, 0.2) 0.4px;
  }
}
</style>

<script>
import db from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")
import ItemSuggestedEventCard from "@/components/item/ItemSuggestedEventCard"

export default {
  components: {
    ItemSuggestedEventCard
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  data () {
    return {
      habit: null,
      suggestedEvents: []
    }
  },
  async created () {
    this.habit = await db.collection("TRAINEE")
      .doc(this.uid)
      .collection("COUNSELING")
      .doc("TUTORIAL")
      .get()
      .then(d => { return d.data() })

    const maxLevel = (this.habit.body.exerciseNumInWeek > 3) ? 4 : 2

    const futureEvents = await db.collection("EVENT")
      // .where("level", "<=", maxLevel)
      .where("startTime", ">=", new Date())
      .limit(20)
      .get()
      .then(q => {
        return q.docs.map(d  => {
          var data = d.data()
          data.id = d.id
          return data
        })
      })
    
    this.suggestedEvents = futureEvents.filter(e => {
      return (e.level <= maxLevel && !e.attendee.includes(this.uid) )
    })
  },
  methods: {
    
  }
}
</script>
